'use client';

import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Link } from '@mui/material';
import { env } from '@repo/env';
import { usePageAction } from '@repo/hooks/usePageAction';
import { useElementViewedContext } from '@repo/segment/Analytics/ElementViewed';

type BankingAssessmentBannerLinkProps = {
  actionName: string;
  callToActionMessage: string;
};

export function BankingAssessmentBannerLink({
  actionName,
  callToActionMessage,
}: BankingAssessmentBannerLinkProps) {
  // TODO: Segment Standardization Cleanup
  const trackPageAction = usePageAction({
    actionName,
    actionSection: 'banking',
  });
  const { fireElementInteracted } = useElementViewedContext();

  const handleLinkClick = () => {
    trackPageAction();
    fireElementInteracted('click', {
      entityName: actionName,
      itemCopy: callToActionMessage,
    });
  };

  return (
    <Link
      component="a"
      sx={{
        backgroundColor: 'white',
        borderRadius: '100px',
        color: 'black',
        paddingTop: '14px',
        paddingBottom: '14px',
        paddingLeft: '16px',
        paddingRight: '16px',
        marginLeft: {
          md: 'auto',
        },
        fontSize: '14px',
        fontWeight: 500,
        lineHeight: '16px',
        gap: '10px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        letterSpacing: '0.113px',
        textDecoration: 'none',
        textTransform: 'uppercase',
        '&:hover': {
          textDecoration: 'none',
          outline: '2px solid #97CB65',
          boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.15)',
        },
      }}
      href={`${env.NEXT_PUBLIC_NW_URL}/banking/assessment`}
      onClick={handleLinkClick}
    >
      {callToActionMessage}
      <ArrowForwardIcon sx={{ fontSize: '22px' }} />
    </Link>
  );
}
